import { axiosWithAuth } from 'blick.react.utils';
import { toast } from 'react-toastify';

export interface SuccessModel<T = unknown> {
    success: boolean;
    responseText: string;
    data?: T;
}

const SKIP_TOAST_HEADER = 'X-Skip-Toast';

function isAccountUrl(url: string | undefined): boolean {
    if (!url) return false;
    const path = url.startsWith('/') ? url : '/' + url;
    return path.startsWith('/api/Account/') || path.startsWith('/api/Account');
}

axiosWithAuth.interceptors.response.use(
    (response) => {
        const data = response.data;
        if (data && typeof data.success === 'boolean') {
            if (!data.success) {
                const message = data.responseText || 'Ошибка';
                if (!response.config?.headers?.[SKIP_TOAST_HEADER] && !isAccountUrl(response.config?.url)) {
                    toast.error(message);
                }
                return Promise.reject(new Error(message));
            }
            return response;
        }
        return response;
    },
    (error) => {
        if (error.response?.status === 401) {
            if (!isAccountUrl(error.config?.url)) {
                window.location.href = '/sign-in';
            }
            return Promise.reject(error);
        }
        const skipToast = error.config?.headers?.[SKIP_TOAST_HEADER] || isAccountUrl(error.config?.url);
        if (!skipToast) {
            const data = error.response?.data;
            let message: string;
            if (data && typeof data.responseText === 'string') {
                message = data.responseText;
            } else if (data && typeof data.error === 'string') {
                message = data.error;
            } else if (typeof data === 'string') {
                message = data;
            } else if (error.message) {
                message = error.message;
            } else {
                message = 'Ошибка сервера';
            }
            toast.error(message);
        }
        return Promise.reject(error);
    }
);

export async function apiCall<T>(
    fn: () => Promise<{ data: SuccessModel<T> }>,
): Promise<T | null> {
    try {
        const response = await fn();
        return response.data?.data ?? null;
    } catch {
        return null;
    }
}

export async function apiCallVoid(
    fn: () => Promise<{ data: SuccessModel }>,
): Promise<boolean> {
    try {
        await fn();
        return true;
    } catch {
        return false;
    }
}

export async function generatedApiCall<T>(
    fn: () => Promise<SuccessModel<T>>,
): Promise<T | null> {
    try {
        const response = await fn();
        return response?.data ?? null;
    } catch {
        return null;
    }
}

export function silentRequest(config: Record<string, unknown>): Record<string, unknown> {
    if (!config.headers) config.headers = {};
    (config.headers as Record<string, unknown>)[SKIP_TOAST_HEADER] = 'true';
    return config;
}

export { axiosWithAuth };